<template>
    <form @submit.prevent="$emit('next')" class="step-form">
      <div class="form-group">
        <label for="firstName">Prénom *</label>
        <input v-model="value.firstName" id="firstName" type="text" required />
      </div>
      <div class="form-group">
        <label for="lastName">Nom *</label>
        <input v-model="value.lastName" id="lastName" type="text" required />
      </div>
      <div class="form-group">
        <label for="company">Entreprise *</label>
        <input v-model="value.company" id="company" type="text" required />
      </div>
      <div class="form-group">
        <label for="position">Poste</label>
        <input v-model="value.position" id="position" type="text" />
      </div>
      <div class="form-group">
        <label for="email">Adresse e-mail professionnelle *</label>
        <input v-model="value.email"  id="email"  type="email" required placeholder="exemple@entreprise.com"/>
      </div>
      <div class="form-group">
        <label for="phone">Numéro de téléphone *</label>
        <input v-model="value.phone"  id="phone"  type="tel"  required title="Entrez un numéro valide (ex: +33 6 12 34 56 78)" placeholder="+33 6 12 34 56 78"/>
      </div>
  
      <p class="small-text">* Champs obligatoires</p>
      <button type="submit" class="submit-button">SUIVANT</button>
    </form>
  </template>
  
  <script>
  export default {
    name: 'StepOne',
    props: {
        value: {
        type: Object,
        required: true
        }
    }
  }
  </script>
  
  <style scoped>
  .step-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .form-group label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.25rem;
  }
  .form-group input {
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #4a6c5e;
  }
  .small-text {
    font-size: 0.875rem;
    color: #666;
  }
  .submit-button {
    background-color: #345b48;
    color: white;
    padding: 0.75rem 1.5rem;
    border: none;
    cursor: pointer;
    align-self: center;
    margin-top: 1rem;
  }
  .form-group input:focus {
    border: 2px solid #4a6c5e; 
    outline: none;
  }

  </style>
  